import React from 'react';

const wrapTags = (text, className) => {
    const regex = /(<\w+>.*?<\s*\/\s*\w+\s*>)/g;
    const textArray = text.split(regex);
    return textArray.map((str, index) => {
        if (regex.test(str)) {
            const betweenTags = str.split(/(<\w+>)(.*?)(<\s*\/\s*\w+\s*>)/g);
            return <span key={index} className={className}>{betweenTags[2]}</span>
        }
        return str;
    });
};

export { wrapTags };